import * as Yup from 'yup';

export const municipalityFormSchema = Yup.object().shape({
  muncipalityName: Yup.string().required('Municipality name is required'),
  municipalityCode: Yup.string().required('Municipality code is required'),
  status: Yup.string().required('Status is required'),
  stateID: Yup.string().required('State is required'),
  contactEmail: Yup.string().email('Invalid email').required('Contact email is required'),
  municipalityCoCStatus: Yup.array().when(['coCRequired', 'coCTemplateID'], {
    is: (coCRequired: boolean, coCTemplateID: any) =>
      coCRequired === true && !!coCTemplateID?.coCTemplateID,
    then: (schema) => schema.min(1, 'At least one report type is required'),
  }),
  municipalityCoCAdditionalDocumentTypesForSubmission: Yup.array().when(
    ['coCRequired', 'coCTemplateID'],
    {
      is: (coCRequired: boolean, coCTemplateID: any) =>
        coCRequired === true && !!coCTemplateID?.coCTemplateID,
      then: (schema) =>
        schema.min(1, 'At least one additional document type is required'),
    }
  ),
});
